import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, className = "", delay = 0, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children }) {
  return (
    <p className="mb-4 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.24em] text-cyan-400">
      <span className="h-px w-8 bg-gradient-to-r from-cyan-400 to-transparent" />
      {children}
    </p>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, className = "" }) {
  return (
    <div className={`max-w-2xl ${className}`}>
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          {title}
        </h2>
      </Reveal>
      {subtitle ? (
        <Reveal delay={0.1}>
          <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">{subtitle}</p>
        </Reveal>
      ) : null}
    </div>
  );
}
